import { getCookie } from "@insite/client-framework/Common/Cookies";

export default () => {
    return getCookie("X-DeviceType") === "Mobile";
}
